import { helper } from '@ember/component/helper';

// {{not-last-index index array}}
// returns boolean
export default helper(function notLastIndex([index, array]: any[] /*, hash*/) {
  return index < array.length - 1;
});
